export default {"src":"/_next/static/media/equity-survey.7343deb5.svg","height":113,"width":110,"blurWidth":0,"blurHeight":0};